// extracted by css-extract-rspack-plugin
export default {"row":"rLbwJkJoS7IX1zat","icon":"AovFBDbtO4bbZApE"};